import { Link } from 'react-router-dom';
import { caseStudies } from '../../data/caseStudies';
import { featuredWork } from '../../data/homeContent';
import { ButtonLink } from '../ui/ButtonLink';
import { Reveal } from '../ui/Reveal';
import styles from './SelectedWork.module.css';

const studies = featuredWork
  .map(({ id, cover }) => ({ ...caseStudies.find((s) => s.id === id), cover }))
  .filter((s) => s.id);

export function SelectedWork() {
  return (
    <section id="work" className={styles.work} aria-labelledby="work-title">
      <div className={styles.inner}>
        <Reveal className={styles.head}>
          <div>
            <p className={styles.eyebrow}>Selected work</p>
            <h2 id="work-title" className={styles.heading}>
              Recent <em>commissions.</em>
            </h2>
          </div>
          <ButtonLink to="/work" variant="outline">
            All work
          </ButtonLink>
        </Reveal>

        <ul className={styles.grid}>
          {studies.map((study, i) => (
            <Reveal as="li" key={study.id} delay={i * 90} className={styles.card}>
              <Link to={`/work#case-${study.id}`} className={styles.link}>
                <div className={styles.frame}>
                  <div className={styles.chrome} aria-hidden="true">
                    <span />
                    <span />
                    <span />
                    <em>{new URL(study.projectURL).hostname.replace(/^www\./, '')}</em>
                  </div>
                  <img
                    src={`/img/case_studies/${study.cover}`}
                    alt={`${study.client} website after the redesign`}
                    width="1400"
                    height="960"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className={styles.meta}>
                  <span>{study.client}</span>
                  <span>
                    {study.industry} · {study.timeframe}
                  </span>
                </div>
                <h3 className={styles.title}>{study.title}</h3>
                <p className={styles.summary}>{study.summary}</p>
              </Link>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
